import { UserType } from "@/app/config/constants";
import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
});

export const registerSchema = (isOrganization = false) =>
  z
    .object({
      title: z
        .string({
          required_error: "Title is required",
        })
        .min(1, "Title is required"),

      dob: z.string().optional().nullable(),

      first_name: z
        .string({
          required_error: "First name is required",
        })
        .min(1, "First name is required"),

      last_name: z
        .string({
          required_error: "Last name is required",
        })
        .min(1, "Last name is required"),

      email: z
        .string({
          required_error: "Email is required",
        })
        .email("Invalid email address"),

      password: z
        .string({
          required_error: "Password is required",
        })
        .min(8, "Password must be at least 8 characters"),
      password_confirmation: z.string({
        required_error: "Password confirmation is required",
      }),
      type: z
        .nativeEnum(UserType, {
          required_error: "Type is required",
        })
        .default(UserType.User),

      organization_name: isOrganization
        ? z
            .string({ required_error: "Organization name is required" })
            .min(1, "Organization name is required")
        : z.string().optional(),

      organization_seats: isOrganization
        ? z
            .number({ required_error: "Number of seats is required" })
            .min(5, "Number of seats must be at least 5")
        : z.number().optional(),

      organization_invoice_period: isOrganization
        ? z.string({ required_error: "Time period is required" })
        : z.string().optional(),
    })
    .refine((data) => data.password === data.password_confirmation, {
      message: "Passwords don't match",
      path: ["password_confirmation"],
    });

export const forgotPasswordSchema = z.object({
  email: z.string().email("Invalid email address"),
});

export const resetPasswordSchema = z
  .object({
    email: z
      .string({
        required_error: "Email is required",
      })
      .email("Invalid email address"),
    password: z
      .string({
        required_error: "Password is required",
      })
      .min(8, "Password must be at least 8 characters"),
    password_confirmation: z.string({
      required_error: "Password confirmation is required",
    }),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords don't match",
    path: ["password_confirmation"],
  });

export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<ReturnType<typeof registerSchema>>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
